import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useCustomerService } from "contexts/ServiceContext";
import { ApiStatusException } from "services/apiErrors";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";

const useCustomers = (): UseQueryResult<Customer[]> => {
  const customerService = useCustomerService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST);
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR);

  return useQuery({
    queryKey: ["customers"],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "Customers",
      });
      return customerService
        .getCustomerList()
        .catch((err: ApiStatusException) => {
          trackQueryError(
            {
              statusCode: err.statusCode as number,
              message: err.message,
            },
            eventId
          );
          throw err;
        });
    },
    select: (data) => data.value,
  });
};

export default useCustomers;
